import { render, staticRenderFns } from "./ExaminationPaper.vue?vue&type=template&id=3713514e&scoped=true"
import script from "./ExaminationPaper.vue?vue&type=script&lang=js"
export * from "./ExaminationPaper.vue?vue&type=script&lang=js"
import style0 from "./ExaminationPaper.vue?vue&type=style&index=0&id=3713514e&prod&scoped=true&lang=css"
import style1 from "./ExaminationPaper.vue?vue&type=style&index=1&id=3713514e&prod&lang=less&scoped=true"
import style2 from "./ExaminationPaper.vue?vue&type=style&index=2&id=3713514e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713514e",
  null
  
)

export default component.exports